module.exports = __webpack_public_path__ + "images/emoji/diamonds.f10c1363b6ab74fac6d6.png";